<template>
  <div>
    <v-container fluid class="content_product1 rounded-lg">
        <v-row class="fill-width mt-3">
            <v-row class="mx-3">
                <v-col cols="3.5" sm="3.5">
                    <v-text-field
                        background-color="#EDF2F7"
                        filled
                        v-model="search.name"
                        label="Tên vai trò"
                        placeholder="Nhập Tên vai trò"
                        @keyup="debounceInput"
                    ></v-text-field>
                </v-col>
            </v-row>
        <v-col cols="4" sm="4" align="right" v-if="hasPermissions('Create role')">
            <v-btn color="primary" align="right" @click="openDialogRole">
            Thêm
            </v-btn>
        </v-col>
        </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12" >
          <v-data-table
              :headers="headers"
              :items="dataResult"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)" v-if="hasPermissions('Update role')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete role')">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
        v-model="dialogRole"
        max-width="900"
        persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="d-flex justify-center">
          {{ !is_edit ? 'Thêm mới' : 'Cập nhật'}} vai trò
        </v-card-title>

        <v-card-text>
          <v-row class="mt-5">
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Tên vai trò"
                  v-model="name"
                  placeholder="Tên vai trò"
              ></v-text-field>
            </v-col>
            <v-col cols="12" style="max-height: 500px;overflow-y: auto;">
                <v-row v-for="(group, key) in dataPermission" :key="key">
                    <v-col cols="12" class="py-0">
                        <h4>{{key}}</h4> 
                    </v-col>
                    <v-col cols="3" v-for="(permission, index) in group" :key="index" class="pb-0">
                        <v-checkbox
                            class="mt-0"
                            v-model="permissions"
                            :value="permission.name"
                            :label="permission.name_translate"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" class="py-0">
                        <div cols="12" style="border-bottom:1px dashed;" class="mb-3"></div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                      @click="dialogRole = false"
                  >
                    Hủy
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn v-if="is_edit"
                      color="primary"
                      @click="update"
                  >
                    Lưu
                  </v-btn>
                  <v-btn
                      v-else
                      color="primary"
                      @click="addNew"
                  >
                    Lưu
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {SAVE_ROLE, GET_DETAIL_ROLE, SET_DETAIL_ROLE, UPDATE_DATA_ROLE, DELETE_ROLE, GET_DATA_SEARCH_ROLE} from '@/store/modules/role';
import {GET_LIST_PERMISSION} from '@/store/modules/permission';

import {mapGetters} from 'vuex';
import {debounce} from "debounce";
export default {
  data() {
    return {
      show: false,
      name: '',
      permissions: [],
      dialogRole:false,
      page_number: 1,
      headers: [
        { text: 'ID', value: 'id', align: 'start', },
        { text: 'Tên vai trò', value: 'name' },
        { text: 'Actions', value: 'actions' },
      ],
      search: {
        name: "",
        limit: 10,
      },
      is_edit:false,
    };
  },
  computed:{
    ...mapGetters({
      role: 'role',
      dataResult: "dataSearchRole",
      dataPermission: "permissions",
    })
  },
  watch:{
    role(val){
      if (val && val.id) {
        this.name = val.name;
        this.permissions = val.listPermission ?? [];
      }
    }
  },
  async created() {
    this.search.name = this.$route.query.name || ''
    this.params();
    await this.$store.dispatch(`${GET_DATA_SEARCH_ROLE}`);
    await this.$store.dispatch(`${GET_LIST_PERMISSION}`);
  },
  methods:{
    async editItem(id){
      await this.$store.dispatch(`${GET_DETAIL_ROLE}`, id)
      this.dialogRole = true;
      this.is_edit = true;
    },
    deleteItem(id){
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_ROLE}`,id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_DATA_SEARCH_ROLE);
        }
      })
    },
    async addNew() {
      const _this = this;
      let data = {
        name: this.name,
        permissions: this.permissions
      }
      await this.$store.dispatch(`${SAVE_ROLE}`,data).then((data)=>{
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_DATA_SEARCH_ROLE}`);
          _this.dialogRole = false;
        }else{
          alert(data.data.errors)
        }
      })
    },
    async update() {
      const _this = this;
      let data = {
        id: this.role.id,
        name: this.name,
        permissions: this.permissions
      }
      await this.$store.dispatch(`${UPDATE_DATA_ROLE}`,data).then((data)=>{
        if (data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
                duration:1000,
                position:'top-center'
            })
            _this.$store.dispatch(GET_DATA_SEARCH_ROLE, {});
            _this.dialogRole = false;
            _this.resetData();
        }else{
          alert(data.data.errors)
        }
      });
        this.dialogRole = false;
    },
    async openDialogRole(){
      this.resetData();
      this.dialogRole = true;
      this.is_edit = false;
      await this.$store.commit(`${SET_DETAIL_ROLE}`, {})
    },

    resetData(){
      this.name = '';
      this.permissions = [];
    },
    
    replaceRole() {
      this.$router.replace({
        query: {
          name: this.search.name,
          page_current: parseInt(this.page_number),
        }
      })
    },
    params() {
      let param = {
        name: this.search.name,
      };
      this.$store.dispatch(GET_DATA_SEARCH_ROLE, param);
    },
    debounceInput: debounce(function (e) {
      this.search.name = e.target.value;
      this.params();
      this.replaceRole();
    }, 200)
  }
};
</script>
<style lang="scss">
.content_product1 {
  background: #ffffff !important;

}
</style>
